export interface NavigationAPI {
  goToStudentWork(assignmentWorkId: string, questionId: string): void
}

export class AngularNavigationAPI implements NavigationAPI {
  constructor(private $state: angular.ui.IStateService) {}

  goToStudentWork(assignmentWorkId: string, questionId: string): void {
    this.$state.go("root.account.student-assignment-work", {
      assignmentWorkId,
      questionId,
    })
  }
}
